<!--
  ~ Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
  -->

<div class="content">
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <h6 class="page-header">
        {{ 'energy.deepDive.dataMonitor' | translate }}
      </h6>
    </div>
  </div>

  <div class="container-fluid box">
    <div class="row" id="row-box">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <div class="row">
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-4">
            <mat-label class="label-input pull-right" id="select-building">{{
              'energy.deepDive.selectBuilding' | translate
            }}</mat-label>
          </div>
          <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7">
            <mat-form-field class="form-field-select">
              <mat-select
                multiple
                placeholder="{{
                  'energy.deepDive.selectBuildingPlaceholder' | translate
                }}"
                (selectionChange)="selectBuildingChange($event)"
                [formControl]="buildingMultiCtrl"
                name="buildingMultiCtrl"
                #buildingMultiSelect
                ngDefaultControl
              >
                <mat-option>
                  <ngx-mat-select-search
                    #buildingSearch
                    [formControl]="buildingMultiFilterCtrl"
                    [placeholderLabel]="search"
                    ngDefaultControl
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let item of filteredBuildingsMulti | async"
                  [value]="item"
                >
                  {{ item }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <div class="row" id="select-load">
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <mat-label class="label-input pull-right" id="select-loads">{{
              'energy.deepDive.selectLoads' | translate
            }}</mat-label>
          </div>
          <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7">
            <mat-form-field class="form-field-select">
              <mat-select
                id="loadUIselectId"
                [formControl]="loadMultiCtrl"
                placeholder="{{
                  'energy.deepDive.selectLoadsPlaceholder' | translate
                }}"
                multiple
                #loadMultiSelect
                ngDefaultControl
                [(ngModel)]="form.loadsAndMeters"
                (selectionChange)="buildParams($event)"
                [required]="loadUIRequired"
                [disabled]="loadUIDisabled"
              >
                <mat-option>
                  <ngx-mat-select-search
                    #loadSearch
                    [formControl]="loadMultiFilterCtrl"
                    [placeholderLabel]="search"
                    ngDefaultControl
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option
                  #selItem
                  *ngFor="let item of filteredLoadsMulti | async"
                  [value]="item"
                  [disabled]="
                    form.loadsAndMeters.length >= 6 && !selItem.selected
                  "
                >
                  {{ item.displayText }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="Bosch-Ic-information label-input pull-right"
              id="selectLoads"
              matTooltip="{{
                'energy.deepDive.selectLoadsTooltip' | translate
              }}"
            ></mat-icon>
          </div>
        </div>
      </div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <div class="row" id="row-select-params">
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <mat-label class="label-input pull-right" id="select-params">{{
              'energy.deepDive.selectParams' | translate
            }}</mat-label>
          </div>
          <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7">
            <mat-form-field class="form-field-select">
              <mat-select
                multiple
                #paramMultiSelect
                placeholder="{{
                  'energy.deepDive.selectParamsPlaceholder' | translate
                }}"
                [(ngModel)]="criteria.params"
                ngDefaultControl
                [formControl]="paramMultiCtrl"
                [required]="parameterUIRequired"
                [disabled]="parameterUIDisabled"
              >
                <mat-option>
                  <ngx-mat-select-search
                    #paramSearch
                    [formControl]="paramMultiFilterCtrl"
                    ngDefaultControl
                    [placeholderLabel]="search"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option
                  #selParam
                  *ngFor="let item of filteredParamsMulti | async"
                  [value]="item.value"
                  [disabled]="
                    item.value === 'registerenergy' ||
                    (criteria.params.length >= 6 && !selParam.selected)
                  "
                >
                  {{ item.text }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="Bosch-Ic-information label-input pull-right"
              style="width: max-content"
              matTooltip="{{
                'energy.deepDive.selectParamsTooltip' | translate
              }}"
            ></mat-icon>
          </div>
        </div>
      </div>

      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <div class="row" id="dt-input">
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <mat-label class="label-input pull-right" id="select-dateRange">
              {{ 'selectDateRange' | translate }}
            </mat-label>
          </div>
          <div
            class="col-xs-8 col-sm-8 col-md-8 col-lg-9"
            id="monitor-power-daterange"
          >
            <div>
              <input
                id="rangedatepicker"
                class="datepicker datepickerAlign"
                type="text"
                ngxDaterangepickerMd
                [(ngModel)]="datesSelected"
                [showCustomRangeLabel]="true"
                [alwaysShowCalendars]="true"
                [ranges]="ranges"
                [linkedCalendars]="true"
                opens="left"
                ngDefaultControl
                [showClearButton]="true"
                (ngModelChange)="changeDateRange($event)"
                [dateLimit]="9"
              />
            </div>
          </div>
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="Bosch-Ic-information label-input pull-right"
              style="width: max-content"
              matTooltip="{{ 'energy.deepDive.selectDateTooltip' | translate }}"
            ></mat-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="display: flex; justify-content: flex-end">
      <div
        class="col-xs-2 col-sm-2 col-md-2 col-lg-2"
        style="display: flex; justify-content: flex-end; align-items: baseline"
      >
        <button
          id="deepDriveChartBtnID"
          class="mat-raised-button pull-right btngenerate"
          (click)="generateChart()"
        >
          {{ 'energy.testbenchOverview.generate' | translate }}
        </button>
        &nbsp;
        <mat-icon
          aria-hidden="false"
          aria-label="weather icon"
          class="Bosch-Ic-information label-input pull-right"
          style="width: max-content"
          matTooltip="{{ 'energy.deepDive.generateTooltip' | translate }}"
        ></mat-icon>
        &nbsp;
        <button
          class="mat-raised-button pull-right btnClean"
          (click)="resetForm()"
        >
          {{ 'clean' | translate }}
        </button>
        &nbsp;
        <mat-icon
          aria-hidden="false"
          aria-label="weather icon"
          class="Bosch-Ic-information cleanTooltip pull-right"
          style="width: max-content"
          matTooltip="{{ 'energy.deepDive.cleanTooltip' | translate }}"
        ></mat-icon>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="panel-body chartpanel text-center" *ngIf="!isData">
        <div
          class="col-xs-8 col-sm-8 col-md-8 col-lg-8"
          id="no-data"
          style="line-height: 300px"
        >
          {{ 'noDataToDisplay' | translate }}
        </div>
      </div>
      <div class="panel-body chartpanel text-center" *ngIf="isData">
        <div [chart]="areaChart" *ngIf="isData"></div>
      </div>
    </div>
  </div>
</div>
